import type { ComponentProps } from "react";
import type { Table } from "@narmi/design_system";

export const WIRE_COL_LAYOUT = {
  s: "44px 1fr 1fr 1fr 1fr 120px 100px 80px 180px",
  m: "44px 1fr 1fr 1fr 1fr 120px 100px 80px 180px",
  l: "44px 1fr 1fr 1fr 1fr 120px 100px 80px 180px",
};

export const WIRE_COL_VISIBILITY: ComponentProps<
  typeof Table
>["colVisibility"] = [
  "*", // checkbox
  "*", // name
  "*", // account
  "*", // routing
  "*", // street_address
  "*", // city
  "*", // region_code
  "*", // postal_code
  "*", // action
];

export const WIRE_CATEGORY_KEYS = [
  "name",
  "account_number",
  "routing_number",
  "street_address",
  "city",
  "region_code",
  "postal_code",
];
